// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","container":"container-19Lj9","thumb":"thumb-3G-Pl","thumbImg":"thumbImg-3J6EE","desc":"desc-jQaFi","name":"name-3TltP","url":"url-11f56","distance":"distance-pq1u-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/gear/_gearItem.css
// module id = 1216
// module chunks = 1